// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { getPopupButtonHeight, getPopupSize } from '../utils';

import { Container, Position, TransitionGroup, HueWarningMessage } from './style';
import messages from '~/core/domains/schedule/intl';

type Props = {
    height: number,
    picker?: React.Element<*>,
    isHueDevice: boolean,
    isGroupAndHasHueDevices: boolean,
    showingPopup: boolean,
    width: number
};

export default function PickerContainer({
    height,
    picker,
    showingPopup,
    width,
    isHueDevice,
    isGroupAndHasHueDevices
}: Props) {
    const popupSize = getPopupSize(height) * 0.9;
    const popupButtonHeight = getPopupButtonHeight(height) + (isHueDevice || isGroupAndHasHueDevices ? 50 : 0);

    return (
        <TransitionGroup
            component="div"
            enter={{ animation: { opacity: 1 }, duration: 300 }}
            leave={{ animation: { opacity: 0 }, duration: 300 }}
            style={{
                transform: `translate3d(${width / 2}px, ${height / 2.25}px, 0)`
            }}
            transform={`translate(${width / 2} ${height / 2})`}
        >
            {showingPopup && (
                <Position>
                    <Container
                        size={popupSize}
                        style={{
                            transform: `translate3d(${-popupSize / 2}px, ${-(popupSize + popupButtonHeight) / 2}px, 0)`
                        }}
                        transform={`translate(${-popupSize / 2} ${-(popupSize + popupButtonHeight) / 2})`}
                    >
                        {(isHueDevice || isGroupAndHasHueDevices) && (
                                <FormattedMessage {...messages.hueWarningMessage}>
                                    {message => <HueWarningMessage>{message}</HueWarningMessage>}
                                </FormattedMessage>
                            )}
                        {picker}
                    </Container>
                </Position>
            )}
        </TransitionGroup>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/picker-container/component.js